'use strict';

var Base = require('./Base');

/*
 Makes an AJAX request and puts the results into a DOM element.

 Example usage:
 this.ajaxRequest = new MITS.AjaxAPI.Request();
 this.ajaxRequest.setContentContainer(containerId);
 this.ajaxRequest.setRequestUrl(url);
 this.ajaxRequest.addCompleteEvent(someFunction);

 this.ajaxRequest.getContent();
 */

/**
 *
 * @param url
 * @param container A DOM element or the ID of a DOM element.
 * @param options
 * @constructor
 */
var Request = function (url, container, options) {
    this.initialize(url, container, options);
};

jQuery.extend(jQuery.extend(Request.prototype, Base.prototype), {
    requestUrl: null,
    scope: null, //not used unless by sub-classes
    method: null, //get or post, defaults to post
    parameters: null,

    initialize: function(url, container, options) {
        this.requestUrl = url;

        if (typeof container === 'string') {
            this.contentContainer = document.getElementById(container);
        } else {
            this.contentContainer = container;
        }

        if (options) {
            this.scope = options.scope;
            this.method = options.method;
            this.evaluateJavascript = options.evaluateJavascript;
            this.parameters = options.parameters;
        }

        this.initializeEventHandlers();
    },

    /*
     Public Getters / Setters
     */
    getMethod: function () {
        return this.method;
    },
    setMethod: function (method) {
        if (method) {
            this.method = method.toLowerCase();
        }
    },

    setRequestUrl: function (url) {
        this.requestUrl = url;
    },
    getRequestUrl: function () {
        return this.requestUrl;
    },


    /*
     Overrides: MITS.AjaxAPI.Base
     */
    getContent: function () {
        this.submitEvents.executeEvents();

        try {
            var jQueryOptions = {
                type: this.getMethod() || 'POST',
                data: this.parameters,
                success: this.successEvents.executeEvents.bind(this.successEvents),
                complete: this.completeEvents.executeEvents.bind(this.completeEvents),
                error: this.failureEvents.executeEvents.bind(this.failureEvents),
                url: this.getRequestUrl(),
                dataType: 'html'
            };

        } catch (e) {
            console.error('error getting jquery options ' + e);
        }

        jQuery.ajax(jQueryOptions);
        return false;
    }
});

module.exports = Request;


//////////////////
// WEBPACK FOOTER
// ./mits/AjaxAPI/Request.js
// module id = 10
// module chunks = 0